(() => {
  const ROOT = '[data-tab-slider]';
  const instances = new WeakMap();

  function build(root) {
    if (instances.has(root)) return;
    if (typeof window.Swiper === 'undefined') return;

    const container = root.querySelector('[data-tab-slider-swiper]');
    if (!container) return;

    const tabs = root.querySelectorAll('[data-tab-index]');
    const slideCount = container.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    const prevEl = root.querySelector('[data-nav="prev"]');
    const nextEl = root.querySelector('[data-nav="next"]');
    const loop = slideCount > 1;

    const swiper = new window.Swiper(container, {
      slidesPerView: 1,
      loop,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
      on: {
        slideChange(sw) {
          tabs.forEach((tab, i) => tab.classList.toggle('is-active', i === sw.realIndex));
        },
      },
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.tabIndex);
        if (swiper.params.loop) swiper.slideToLoop(index);
        else swiper.slideTo(index);
      });
    });

    instances.set(root, swiper);
  }

  function destroy(root) {
    const swiper = instances.get(root);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(root);
  }

  function apply(scope = document) {
    scope.querySelectorAll(ROOT).forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT).forEach(destroy);
  });
})();
